export const scrollIntoView = (id: string) => {
	const element = document.getElementById(id);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
	} else {
		console.warn("Couldn't find element with id: " + id);
	}
};
